export const UPDATE_ALL = 'UPDATE_ALL';

export const BEHAVIOR_OPTIONS = {
  ADD: 'Add',
  EDIT: 'Edit',
  ARCHIVE: 'Archive',
  ARCHIVE_OR_DELETE: 'Archive or delete',
} as const;

export const EMPTY_LISTING = {
  address: '',
  isRoomForRent: false,
  isMultifamily: false,
  numUnits: '',
  propertyType: '',
  unit: '',
  listingAlias: '',
  customerId: '',
};

export const EMPTY_ERROR = {
  address: '',
  propertyType: '',
  unit: '',
  numUnits: '',
  customerId: '',
};

export const STEPS = {
  CONFIRM_ADDRESS: 'CONFIRM_ADDRESS',
  CREATE_LISTING: 'CREATE_LISTING',
  INPUT_ADDRESS: 'INPUT_ADDRESS',
  SELECT_ACTION: 'SELECT_ACTION',
  UNITS_ADDED: 'UNITS_ADDED',
  UNIT_ENTRY: 'UNIT_ENTRY',
} as const;
